import HttpService from "./http.service";

class AuthService {
  login = async (payload) => {
    const loginEndpoint = "login";
    const response = await HttpService.post(loginEndpoint, payload);
    return response;
  };

  register = async (credentials) => {
    const registerEndpoint = "register";
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const logoutEndpoint = "logout";
    return await HttpService.post(logoutEndpoint);
  };

  forgotPassword = async (payload) => {
    const forgotPassword = "password-forgot";
    return await HttpService.post(forgotPassword, payload);
  };

  resetPassword = async (credentials) => {
    const resetPassword = "password-reset";
    return await HttpService.post(resetPassword, credentials);
  };

  getProfile = async () => {
    const getProfile = "me";
    return await HttpService.get(getProfile);
  };

  updateProfile = async (newInfo) => {
    const updateProfile = "me";
    return await HttpService.patch(updateProfile, newInfo);
  };

  updateExperimentation = async (newInfo) => {
    const updateExperimentation = "me/experimentation";
    return await HttpService.post(updateExperimentation, newInfo);
  };

  registerEmailVerification = async (payload) => {
    const registerEmailVerification = "register-email-verification";
    return await HttpService.post(registerEmailVerification, payload);
  };

  registerUser = async (payload) => {
    const registerUser = "register-user";
    return await HttpService.post(registerUser, payload);
  };

  linkedinUserExists = async (payload) => {
    const linkedinUserExists = "linkedin-user-exists";
    return await HttpService.post(linkedinUserExists, payload);
  };

  getLinkedinProfileDetails = async (payload) => {
    const getLinkedinProfileDetails = "linkedin-profile-details";
    return await HttpService.post(getLinkedinProfileDetails, payload);
  };

  saveLinkedinProfileDetails = async (payload) => {
    const saveLinkedinProfileDetails = "save-profile-details";
    return await HttpService.post(saveLinkedinProfileDetails, {
      userProfileDetails: payload,
    });
  };
}

export default new AuthService();
